import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import alertIcon from '../../icons/alert.svg';
import SVGIcon from '../SVGIcon';
import Tooltip from '../Tooltip';
import styles from './TextualControl.module.scss';

const propTypes = {
  append: PropTypes.node,
  error: PropTypes.string,
  label: PropTypes.node,
  prepend: PropTypes.node,
  type: PropTypes.string.isRequired,
  inlineError: PropTypes.bool.isRequired,
};

const defaultProps = {
  append: null,
  error: null,
  label: null,
  prepend: null,
};

const TextualControl = ({
  append,
  inlineError,
  error,
  label,
  prepend,
  ...inputProps
}) => (
  <label className={error && styles.error}>
    {label && <div className={styles.label}>{label}</div>}
    <div
      className={classNames(styles.inputContainer, {
        [styles.disabled]: inputProps.disabled,
      })}
    >
      {prepend && <div className={styles.prepend}>{prepend}</div>}
      <input {...inputProps} />
      {append && <div className={styles.append}>{append}</div>}
      {inlineError && error && (
        <div className={styles.errorContainer}>
          <Tooltip
            display="block"
            placement="top"
            popOverPortal={document.body}
            tooltip={error}
            trigger="hover"
          >
            <SVGIcon className={styles.errorIcon}>{alertIcon}</SVGIcon>
          </Tooltip>
        </div>
      )}
    </div>
  </label>
);

TextualControl.propTypes = propTypes;
TextualControl.defaultProps = defaultProps;

export default TextualControl;
